import {
  LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM,
  LOOKUP_VIP_POINT_ACTIVITY
} from 'store/ducks/rewards/types';

export const fetchVipPointActivity = nextPageToken => ({ type: LOOKUP_VIP_POINT_ACTIVITY, nextPageToken });
export const onLookupRewardsTransparencyPointsForItem = () => ({ type: LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM });
